import React from 'react';
import styled from 'styled-components/macro';
import { observer } from 'mobx-react';

import { useDataStore } from 'state/DataStore';

import Popup from 'components/Popup';


const AppSettingsPopup = observer(({ isOpen, onClose }) => {
    const dataStore = useDataStore();
    const { appSettings } = dataStore;

    const handleHideEmailShortlistChange = (e) => {
        dataStore.updateAppSetting('hideEmailShortlistButton', e.target.checked);
    };

    const handleSyncModeChange = (e) => {
        dataStore.updateAppSetting('syncMode', e.target.value);
    };

    return (
        <Popup isOpen={isOpen} onClose={onClose} fullScreen={false} closeButtonInside={true}>
            <Container>
                <Title>App Settings</Title>
                <Content>
                    <Row>
                        <CheckboxLabel>
                            <Checkbox
                                type="checkbox"
                                checked={appSettings.hideEmailShortlistButton || false}
                                onChange={handleHideEmailShortlistChange}
                            />
                            Hide email shortlist button
                        </CheckboxLabel>
                    </Row>
                    <Row>
                        <SyncModeLabel>
                            Sync mode:
                        </SyncModeLabel>
                        <SyncModeSelect
                            value={appSettings.syncMode || 'standalone'}
                            onChange={handleSyncModeChange}
                        >
                            <option value="standalone">Standalone</option>
                            <option value="master">Master (controls servant)</option>
                            <option value="servant">Servant (follows master)</option>
                        </SyncModeSelect>
                    </Row>
                </Content>
            </Container>
        </Popup>
    );
});


export default AppSettingsPopup;


const Container = styled.div`
    width: 90vw;
    max-width: 100rem;
    min-height: 90vh;
    padding: 6rem 8rem 5rem 8rem;

    background: ${props => props.theme.app_background};
`;

const Title = styled.h2`
    margin: 0 0 4rem 0;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
`;

const Row = styled.div`
    display: flex;
    align-items: center;
`;

const CheckboxLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 1.5rem;
    cursor: pointer;
    font-size: 1.6rem;
`;

const Checkbox = styled.input`
    width: 2rem;
    height: 2rem;
    cursor: pointer;
`;

const SyncModeLabel = styled.span`
    font-size: 1.6rem;
    min-width: 12rem;
`;

const SyncModeSelect = styled.select`
    font-size: 1.6rem;
    padding: 0.5rem 1rem;
    cursor: pointer;
`;
